import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=4141c0c3&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141c0c3",
  null
  
)

export default component.exports